<template>
    <div class="page flex-col">
        <div class="group_2 flex-col">
            <div class="image-text_1 flex-col justify-between">
                <img class="image_1" referrerpolicy="no-referrer" src="@/assets/img/footer/2.png" />
                <span class="text-group_1">微信立即咨询</span>
            </div>
            <div class="box_2"></div>
            <div class="test_div">
                <span class="text_8">©{{ new Date().getFullYear() }}&nbsp;北京市东元（深圳）律师事务所<br />
                    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021147654号-1</a>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "MobileFooter",
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.page {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    width: 390px;
    height: 200px;
    overflow: hidden;
    margin-top: 20px;
}

.group_1 {
    background-color: rgba(238, 238, 238, 1);
    height: 1px;
    width: 354px;
    margin: 58px 0 26px 18px;
}

.box_1 {
    background-color: rgba(238, 238, 238, 1);
    width: 354px;
    height: 1px;
    margin: 12px 0 0 18px;
}

.group_2 {
    background-color: rgba(250, 250, 250, 1);
    width: 390px;
    height: 200px;
}

.image-text_1 {
    width: 82px;
    height: 82px;
    margin: 18px 0 0 154px;
}

.image_1 {
    width: 82px;
    height: 82px;
}

.text-group_1 {
    width: 73px;
    height: 15px;
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
    margin: 6px 0 0 4px;
}

.section_2 {
    width: 354px;
    height: 354px;
    margin: 13px 0 302px 18px;
}

.box_2 {
    background-color: rgba(211, 211, 211, 1);
    width: 354px;
    height: 1px;
    margin: 32px 0 0 18px;
}

.test_div {
    margin: 12px 0 0 0;
    width: auto;
}

.text_8 {
    width: 189px;
    height: auto;
    overflow-wrap: break-word;
    color: rgba(211, 211, 211, 1);
    font-size: 10px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: center;

    a {
        text-decoration: none;
        color: rgba(211, 211, 211, 1);
        ;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MobileFooter/index.vue